module.exports = __webpack_public_path__ + "images/landlord.adfd70c988da68e1a8fbcaf6a43279cc.svg";